<template>
	<h3 class="title mb_20 tal">{{ $t('c2c.sell.title') }}</h3>
	<div v-if="step === 0">
		<p class="mb_10">{{ $t('c2c.sell.head1') }}</p>
		<div class="info_box mb_20">
			<p class="info_text">
				{{ $t('c2c.sell.text1') }}<br />
				{{ $t('c2c.sell.text2') }}
			</p>
		</div>

		<p class="mb_10">{{ $t('c2c.sell.head2') }}</p>
		<div class="info_box mb_20">
			<p class="info_text">
				{{ $t('c2c.sell.text3') }}<br />
				{{ $t('c2c.sell.text4') }}<br />
				{{ $t('c2c.sell.text5') }}
			</p>
		</div>

		<p class="mb_10">{{ $t('c2c.sell.head3') }}</p>
		<div class="info_box mb_20">
			<p class="info_text">
				{{ $t('c2c.sell.text6') }}<br />
				{{ $t('c2c.sell.text7') }}
			</p>
		</div>

		<p class="mb_10">{{ $t('c2c.sell.head4') }}</p>
		<div class="info_box mb_20">
			<p class="info_text">
				{{ $t('c2c.sell.text8') }}<br />
				{{ $t('c2c.sell.text9') }}<br />
				{{ $t('c2c.sell.text10') }}
			</p>
		</div>

		<div class="button_area">
			<button class="" @click="$emit('closeModal')">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="stepNext">
				{{ $t('button.next') }}
			</button>
		</div>
	</div>

	<form @submit.prevent v-if="step === 1" class="sell_asset">
		<div
			:class="[
				!selectedMarket ? 'mb_20' : 'mb_5',
				'd_flex',
				'align_items_center',
			]"
		>
			<div class="w50">
				<CustomSelectBox
					ref="sourceSelect"
					:placeholder="$t('c2c.sell.placeholder1')"
					:options="sourceAssets"
					:show-account="true"
					@selectItem="selectSourceAsset"
				></CustomSelectBox>
			</div>

			<div class="space_arrow">
				<img src="@/assets/images/icon/arrow_right.png" alt="" />
			</div>

			<div class="w50">
				<CustomSelectBox
					ref="targetSelect"
					:placeholder="$t('c2c.sell.placeholder2')"
					:show-account="true"
					:disable="targetDisable"
					:options="targetAssets"
					@selectItem="selectTargetAsset"
				></CustomSelectBox>
			</div>
		</div>
		<p v-if="selectedMarket" class="mb_20 fs_14">
			{{ $t('c2c.sell.text11') }}: {{ selectedMarket.deal_fee_rate }}
		</p>

		<div class="divide_line mt_0"></div>

		<div class="d_flex mb_20">
			<div class="w50 mr_10">
				<p class="mb_10">{{ $t('c2c.sell.head5') }}</p>
				<input
					type="text"
					class="tar"
					v-model="sourceAmount"
					placeholder="0"
					:disabled="amountDisable"
				/>
			</div>
			<div class="w50">
				<div class="d_flex align_items_center mb_10">
					<p class="mr_10">{{ $t('c2c.sell.head6') }}</p>
					<div class="switch_toggle">
						<label>
							<input
								type="checkbox"
								true-value="Y"
								false-value="N"
								v-model="useSourceMinAmount"
								:disabled="!selectedMarket"
							/>
							<span></span>
						</label>
					</div>
				</div>

				<input
					type="text"
					v-model="sourceMinAmount"
					class="tar"
					placeholder="0"
					:disabled="useSourceMinAmount === 'N'"
				/>
			</div>
		</div>

		<div class="d_flex mb_20">
			<div class="w50 mr_10">
				<p class="mb_10">{{ $t('c2c.sell.head7') }}</p>
				<input
					type="text"
					class="tar"
					:disabled="!spreadDisable"
					v-model="spreadRatio"
				/>
			</div>
			<div class="w50">
				<p class="mb_10">{{ $t('c2c.sell.head8') }}</p>
				<input
					v-if="!minDisable"
					type="text"
					class="tar"
					:disabled="minDisable"
					v-model="minPrice"
				/>
				<input v-else type="text" class="tar" :value="calcMinPrice" disabled />
			</div>
		</div>
		<Extform
			class="border_t_black mt_20 pt_20"
			v-for="extform in extforms"
			:key="extform.seq"
			v-bind="extform"
			v-model="extform.field_values"
		/>
		<div class="button_area">
			<button class="" @click="stepBack">{{ $t('button.back') }}</button>
			<button
				class="fc_red normal_submit"
				:disabled="!canRegistration"
				@click="sellHandler"
			>
				{{ $t('button.register') }}
			</button>
			<button class="fc_red disabled_submit" disabled>
				{{ $t('button.register') }}
			</button>
		</div>
	</form>
	<ModalView v-if="accountRegistModal" @closeModal="accountRegistModal = false">
		<h3 class="title mb_20">
			{{ $t('rtr_wallet_account-assets.title3') }}
		</h3>
		<AccountRegister
			@closeRegist="closeRegist"
			:asset-info="selectedAsset"
		></AccountRegister>
	</ModalView>
	<ModalMessage v-if="messageModal" @closeModal="messageModal = false">
		<div :class="'status_icon ' + modalIcon"></div>
		<p class="status_text">{{ modalStatusMessage }}</p>
		<div v-if="messageModalMode === 'warning'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button
				class="fc_red"
				@click="(messageModal = false), (accountRegistModal = true)"
			>
				{{ $t('button.new_account') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'information'" class="button_area">
			<button @click="messageModal = false">
				{{ $t('button.cancel') }}
			</button>
			<button class="fc_red" @click="createPrivateDeal">
				{{ $t('button.confirm') }}
			</button>
		</div>
		<div v-if="messageModalMode === 'success'" class="button_area">
			<button
				class="oneBtn"
				@click="(messageModal = false), $emit('closeModal')"
			>
				{{ $t('button.confirm') }}
			</button>
		</div>
	</ModalMessage>
</template>

<script>
import { mapGetters } from 'vuex';
import CustomSelectBox from '@/components/CustomSelectBox';
import { uniqBy } from 'lodash';
import { fetchPrivateMarkets, fetchPrivateMarketForms } from '@/api/market';
import { createPrivateDeal } from '@/api/deal';
import { commonError } from '@/common/dialog';
import ModalView from '@/components/Layout/ModalView';
import ModalMessage from '@/components/Layout/ModalMessage';
import AccountRegister from '@/components/AccountRegister';
import Extform from '@/components/Extform/Extform';

export default {
	name: 'C2cSell',
	emits: ['close', 'closeModal'],
	components: {
		CustomSelectBox,
		ModalView,
		ModalMessage,
		AccountRegister,
		Extform,
	},
	data() {
		return {
			step: 0,
			markets: [],
			selectedSourceSeq: '',
			selectedTargetSeq: '',
			selectedAssetSeq: null,
			sourceAmount: null,
			target: '',
			newAssetSeq: '',
			useSourceMinAmount: 'N',
			useSourceMaxAmount: 'N',
			useMinPrice: 'N',
			useMaxPrice: 'N',
			minPrice: '',
			sourceMinAmount: '',
			spreadRatio: '',
			messageModalMode: '',
			messageModal: false,
			modalIcon: '',
			modalStatusMessage: '',
			accountRegistModal: false,
			extforms: [],
		};
	},
	computed: {
		...mapGetters('account', ['accounts']),
		...mapGetters('assets', ['assets', 'registedAssets']),
		sourceAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return asset.seq === market.source_asset_seq;
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		targetAssets() {
			const result = [];
			this.markets.forEach(market => {
				const asset = this.registedAssets.find(asset => {
					return (
						market.source_asset_seq === this.selectedSourceSeq &&
						asset.seq === market.target_asset_seq
					);
				});
				if (asset) result.push(asset);
			});
			return uniqBy(result, 'seq');
		},
		selectedSourceAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAccount() {
			return this.accounts.find(item => {
				return item.asset_seq === this.selectedTargetSeq;
			});
		},
		selectedSourceAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedSourceSeq;
			});
		},
		selectedTargetAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedTargetSeq;
			});
		},
		selectedMarket() {
			return this.markets.find(item => {
				return (
					item.source_asset_seq === this.selectedSourceSeq &&
					item.target_asset_seq === this.selectedTargetSeq
				);
			});
		},
		targetDisable() {
			return (
				this.selectSourceAsset.is_active === 'Y' && !this.selectedSourceAccount
			);
		},
		amountDisable() {
			if (
				!this.selectedSourceAsset ||
				(!this.selectedSourceAccount &&
					this.selectedSourceAsset.is_active === 'Y')
			)
				return true;
			if (
				!this.selectedTargetAsset ||
				(!this.selectedTargetAccount &&
					this.selectedTargetAsset.is_active === 'Y')
			)
				return true;

			return false;
		},
		spreadDisable() {
			if (this.selectedMarket) {
				if (this.selectedMarket.use_follow_direct_market === 'Y') return true;
				else return false;
			} else {
				return false;
			}
		},
		minDisable() {
			return !(
				this.selectedMarket &&
				this.selectedMarket?.use_follow_direct_market === 'N'
			);
		},
		selectedAsset() {
			return this.registedAssets.find(item => {
				return item.seq === this.selectedAssetSeq;
			});
		},
		canRegistration() {
			return !!this.sourceAmount;
		},
		calcMinPrice() {
			if (
				this.selectedMarket &&
				this.selectedMarket.use_follow_direct_market === 'Y'
			) {
				return this.selectedMarket.direct_market_basic_rate * this.spreadRatio;
			} else {
				return null;
			}
		},
	},
	mounted() {
		this.init();
	},
	watch: {
		selectedSourceSeq() {
			this.selectedTargetSeq = '';
			if (this.$refs.targetSelect) this.$refs.targetSelect.initSelected();
		},
		sourceAmount(value) {
			if (!value) return;
			this.sourceAmount = value
				.replace(/[^0-9.]/g, '')
				.replace(/(\..*)\./g, '$1');
		},
		selectedMarket(value) {
			if (value && value.use_follow_direct_market === 'Y') this.spreadRatio = 1;
			else this.spreadRatio = '';

			this.sourceAmount = null;
			this.minPrice = '';
			this.useSourceMinAmount = 'N';
			this.sourceMinAmount = '';
			this.loadExtforms();
		},
		step(value) {
			if (value === 1) {
				this.initForm();
			}
		},
	},
	methods: {
		init() {
			this.loadPrivateMarkets();
		},
		async loadPrivateMarkets() {
			const { data } = await fetchPrivateMarkets().catch(commonError);
			this.markets = data.filter(item => {
				return item.is_active === 'Y';
			});
		},
		async loadExtforms() {
			this.extforms = [];
			if (!this.selectedMarket) return;

			const { forms } = await fetchPrivateMarketForms(
				this.selectedMarket.seq,
				'MARKET_PRIVATE_DEAL',
			).catch(commonError);
			this.extforms = forms.map(item => ({ ...item, field_values: [] }));
		},
		checkAccount(target) {
			const assetSeq =
				target === 'source' ? this.selectedSourceSeq : this.selectedTargetSeq;
			const asset = this.registedAssets.find(item => {
				return item.seq === assetSeq;
			});

			const account = this.accounts.find(item => {
				return item.asset_seq === assetSeq;
			});
			if (account || asset.is_active !== 'Y') return;

			this.selectedAssetSeq = assetSeq;
			this.target = target;
			if (target === 'source') {
				this.newAssetSeq = this.selectedSourceSeq;
				this.selectedSourceSeq = '';
				this.$refs.sourceSelect.initSelected();
			} else {
				this.newAssetSeq = this.selectedTargetSeq;
				this.selectedTargetSeq = '';
				this.$refs.targetSelect.initSelected();
			}
			this.modalStatusMessage = this.$t('modal.message.no_account');
			this.modalIcon = 'warning';
			this.messageModalMode = 'warning';
			this.messageModal = true;
		},
		selectSourceAsset(assetSeq) {
			this.selectedSourceSeq = assetSeq;
			this.checkAccount('source');
		},
		selectTargetAsset(assetSeq) {
			this.selectedTargetSeq = assetSeq;
			this.checkAccount('target');
		},
		closeRegist(seq) {
			if (seq) {
				const accountInfo = this.accounts.find(item => {
					return item.seq === seq;
				});
				this.target === 'source'
					? this.$refs.sourceSelect.selectItem(accountInfo.asset_seq)
					: this.$refs.targetSelect.selectItem(accountInfo.asset_seq);
			}
			this.accountRegistModal = false;
		},
		initForm() {
			this.messageModal = false;
			this.selectedSourceSeq = '';
			this.selectedTargetSeq = '';
			this.sourceAmount = null;
			this.sourceMinAmount = '';
			this.spreadRatio = '';
			this.minPrice = '';
			if (this.$refs.sourceSelect) this.$refs.sourceSelect.initSelected();
			if (this.$refs.targetSelect) this.$refs.targetSelect.initSelected();
		},
		stepBack() {
			this.step--;
		},
		stepNext() {
			this.step++;
		},
		sellHandler() {
			this.modalIcon = 'information';
			this.messageModalMode = 'information';
			this.modalStatusMessage = this.$t('modal.message.set_sell');
			this.messageModal = true;
		},
		async createPrivateDeal() {
			const params = {
				market_seq: this.selectedMarket.seq,
				account_seq: this.selectedSourceAccount?.seq,
				target_account_seq: this.selectedTargetAccount?.seq,
				source_amount: this.sourceAmount,
				use_source_min_amount: this.useSourceMinAmount,
				source_min_amount: this.sourceMinAmount,
				use_source_max_amount: this.useSourceMaxAmount,
				source_max_amount: '',
				use_min_price: this.useMinPrice,
				use_max_price: this.useMaxPrice,
				min_price: this.minPrice,
				max_price: '',
				spread_ratio: this.spreadRatio,
				field_values: [].concat(
					...this.extforms.map(item => item.field_values),
				),
			};
			await createPrivateDeal(params)
				.then(() => {
					this.$store.dispatch('account/getAccounts');
					this.modalIcon = 'success';
					this.messageModalMode = 'success';
					this.modalStatusMessage = this.$t('modal.message.registered');
					this.messageModal = true;
				})
				.catch(e => {
					this.messageModal = false;
					commonError(e);
				});
		},
	},
};
</script>

<style scoped>
.disabled_submit {
	border-radius: 0 0 20px 0;
}
.sell_asset:invalid .normal_submit {
	display: none;
}
.sell_asset:valid .disabled_submit {
	display: none;
}
</style>
